import "./../styles.scss";

import { notification } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import CloseModal from "../../../components/icons/CloseModal";
import amplitude from "../../../externals/amplitude";
import { editZeeFolderValidation } from "../../../utils/validations";

const EditFolder = ({ ...props }) => {
  const { editmodalOpen, setEditModalOpen, getFolder, folderDetails, costumFields, folderNames, id } = props;
  const [disable, setDisable] = useState(false);
  const [initialValues, setInitialValues] = useState({
    name: folderDetails?.name,
  });
  const closeModal = () => {
    setEditModalOpen(false);
  };

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      name: folderDetails?.name,
      _id: folderDetails?._id,
    });
  }, [folderDetails]);

  //Edit existing folder
  const handleSubmit = () => {
    if (folderNames.filter((e) => e._id !== initialValues?._id && e.name === initialValues?.name).length > 0) {
      notification["error"]({ message: "Package Name Already Exists" });
      amplitude.logEvent("folder_already_exists", { folder: initialValues?.name, folder_id: initialValues?._id });
    } else {
      setDisable(false);
      const payload = {
        existingName: folderDetails?.name,
        folder: {
          name: initialValues?.name,
        },
        settingId: costumFields?._id,
        action: "update",
        entityId: id,
      };

      getFolder(payload);
      closeModal();
      amplitude.logEvent("folder_updated", { folder: initialValues?.name, folder_id: initialValues?._id });
    }
  };

  //get folder name
  const editFolderName = (e, setFieldValue) => {
    setFieldValue("name", e);
    setInitialValues({ ...initialValues, name: e });
  };

  return (
    <>
      <Modal
        isOpen={editmodalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Folder Name</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialValues} validationSchema={editZeeFolderValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Folder Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="name"
                        value={initialValues?.name}
                        onChange={(e) => editFolderName(e.target.value, setFieldValue)}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <button className="btn btn-primary" type="submit">
                      Edit
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditFolder;
